/* eslint-disable @typescript-eslint/no-explicit-any */
import { login as h5Login } from '@kk/h5-sdk';
import { webview, ua } from '@kk/utils';
import toast from '@kk/toast';
import { miniNav } from '@kk-activity-factory/utils';
import bus, { busEvent } from '@kk-activity-factory/bus';

function getOutsideLoginUrl() {
    return /\.kuaikanmanhua.com/.test(location.host)
        ? 'https://m.kuaikanmanhua.com/mob/login/'
        : 'https://m.quickcan.cn/mob/login/';
}

export default function (options: any) {
    const disableOutsideDeeplink =
        typeof options?.disableOutsideDeeplink === 'boolean'
            ? options.disableOutsideDeeplink
            : false;
    if (ua.miniprogram) {
        if ((window as any).isJsSDKReady) {
            miniNav('/pages/login/login');
        } else {
            toast.show('资源图片努力加载ing，请稍等~');
            setTimeout(() => miniNav('/pages/login/login'), 2000);
        }
    } else {
        if (webview.isKuaikan) {
            h5Login(options);
        } else if (disableOutsideDeeplink) {
            window.location.href = `${getOutsideLoginUrl()}?redirect=${encodeURIComponent(
                location.href
            )}`;
        } else {
            bus.$emit(busEvent.OPEN_DEEPLINK_GUIDE);
        }
    }
}
